import React from 'react';

import Icon from '../Icon/Icon';

const ArrowRightIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <path
                d='M15.0938 6.96484L20.3245 12.1956L15.0938 17.4264'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path d='M19 12.1958H4' stroke='currentColor' strokeWidth='1.5' strokeLinecap='square' />
        </Icon>
    );
};

export default ArrowRightIcon;
